var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 1H1V50H50V1Z",
    stroke: "#FFCB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0561 21.6687L23.0562 21.6687L29.0719 24.7172L29.072 24.7173L28.846 25.1633C29.0249 25.2539 29.0218 25.5104 28.8408 25.5967L23.0561 21.6687ZM23.0561 21.6687C22.5627 21.4187 21.9795 21.7774 21.9795 22.3302V28.2479C21.9795 28.793 22.548 29.1521 23.0403 28.9171L23.0561 21.6687ZM19.0691 18H31.9309C34.1782 18 36 19.8218 36 22.0691V28.4986C36 30.746 34.1782 32.5678 31.9309 32.5678H19.0691C16.8218 32.5678 15 30.746 15 28.4986V22.0691C15 19.8218 16.8218 18 19.0691 18Z",
    fill: "#FFCB00",
    stroke: "#FFCB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.765f76edda9138c769cdb06fc59de36a.svg";
export { ForwardRef as ReactComponent };